import api from '../../services/api';
import { useState, useEffect } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';
import useAlerta from '../../common/components/useAlerta';
import AppSnackbar from '../../common/components/AppSnackbar';
import usePermissoes from '../../common/hooks/usePermissoes';
import Permissoes from '../../common/permissoes';

function Documento() {
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const { hasPermission } = usePermissoes();
    const [textoPesquisa, setTextoPesquisa] = useState("");
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const formatarData = (dataISO) => {
        if (!dataISO) return '';
        const data = new Date(dataISO);
        return data.toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/documento/pesquisa?texto=${textoPesquisa}&page=${page - 1}`);
                setData(response.data.content);
                setTotalPages(response.data.page.totalPages);
            } catch (error) {
                console.error("Erro ao buscar documentos:", error);
            }
        }
        fetchData();
    }, [page, textoPesquisa]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    const handleDownload = async (documento) => {
        try {
            const response = await api.get(`/documento/${documento.id}/download`, { responseType: 'blob' });
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = documento.nomeArquivo || documento.titulo;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            mostrarAlerta("Erro ao baixar o documento!", "error");
            setTimeout(fecharAlerta, 3000);
        }
    };

    return (
        <PageContainer>
            <PageHeader
                title="Documentos"
                searchValue={textoPesquisa}
                onSearchChange={(e) => {
                    setPage(1);
                    setTextoPesquisa(e.target.value);
                }}
                actionLabel={hasPermission(Permissoes.DOCUMENTO_CADASTRO) ? "Adicionar Documento" : undefined}
                actionIcon={<AddCircleOutlineIcon />}
                actionTo="/documento/cadastro"
            />

            <Grid container spacing={2}>
                {data.map((documento, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card>
                            <CardActionArea onClick={() => handleDownload(documento)}>
                                <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <InsertDriveFileOutlinedIcon color="primary" sx={{ fontSize: 32 }} />
                                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }} noWrap>{documento.titulo}</Typography>
                                        <Typography variant="body2" color="text.secondary" noWrap>{documento.nomeArquivo}</Typography>
                                        <Typography variant="caption" color="text.secondary">Enviado em {formatarData(documento.dataUpload)}</Typography>
                                    </Box>
                                    <DownloadOutlinedIcon color="action" />
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
                </Box>
            )}

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default Documento;
